import _get from 'lodash/get';

import { findAllValues } from 'utils/DICTIONARY';

export default function formatRequestStatus(status) {
  const statusMap = findAllValues('order_service_statuses') || {};
  return _get(statusMap, status, '');
}
